import React from 'react';
import {Box, Grid} from '@mui/material';
import {mainPlanTypeType} from '../CreateBuilder/builderFields';
import {transferAmountField} from './builderTransferFields';
import {BuilderPot, BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PotDetails} from '../../../schema-types/PotDetails';
import AutoField from '../../../components/AutoForm/AutoFieldNew';
import {BuilderPlanFeesField} from '../CreateBuilder/BuilderPlanFees';

interface BuilderTransferDestinationAmountsProps {
  pot: BuilderPot | BuilderPot_dentistChildren;
  disabled: boolean;
  mainPlanType: mainPlanTypeType;
}

export const BuilderTransferDestinationAmounts: React.FC<
  BuilderTransferDestinationAmountsProps
> = ({pot, disabled, mainPlanType}) => {
  return (
    <Box mt={1}>
      <Grid container alignContent="flex-start" direction="row" spacing={3}>
        <Grid item xs={6}>
          <AutoField
            field={{
              ...transferAmountField,
              allowZero: true,
              canBeEmpty: true,
              disabled: true,
              id: 'transfer.combinedSingleAmount',
              label: `Single Amount${mainPlanType === 'pension' ? ' (Gross)' : ''}`,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <BuilderPlanFeesField
            pot={pot as unknown as PotDetails}
            inModify={false}
            hasSubplan={false}
            requiresMandate={false}
            productId={undefined}
            providerId={undefined}
            formikKeyPrefixWithoutFee="transfer.destinationValues"
            disabled={disabled}
            helperText="Cannot edit existing ongoing fee using this requirement"
          />
        </Grid>
      </Grid>
    </Box>
  );
};
